import React, { FC, ReactNode, useEffect } from 'react';

import { Box } from '@mui/material';

import { AppTopBar, AppDrawer, useWindowDimensions, MobileMenu } from '@Iot-Bee/standard-web-library';

import { TopPadding } from '../theme';
import { noCacheFetcher } from '../utils/fetch';
import sideMenus from '../components/menu/menuitems';
import { logout } from '../auth/auth';
import { DevicesContextProvider } from '../context/DevicesContext';
import { Theme } from '../Types/types';

const getSideBarWidth = (screenwidth: number) => {
  return screenwidth * 0.15 < 200 && screenwidth > 768 ? '220px' : screenwidth > 768 ? '220px' : '0';
};

interface OutletWrapperProps {
  children: ReactNode;
  theme: Theme | null;
}

const OutletWrapper: FC<OutletWrapperProps> = ({ children, theme }) => {
  const { screenwidth } = useWindowDimensions();

  useEffect(() => {
    // check if the user is logged in every 20 minutes
    noCacheFetcher(`${process.env.REACT_APP_API_URL}checkloggedin`)
      .then(() => {})
      .catch(() => {
        logout();
      });
  }, []);

  return (
    <Box>
      <DevicesContextProvider>
        <AppTopBar handleLogout={logout} />
        {screenwidth > 768 ? (
          <AppDrawer
            menuItems={sideMenus}
            handleLogout={() => logout()}
            backgroundColor={theme?.colors?.navbar}
            menuItemColor={theme?.colors?.navicons}
            logo={theme?.logo}
          />
        ) : (
          <MobileMenu menuItems={sideMenus} handleLogout={() => logout()} />
        )}
        <Box
          component="main"
          sx={{
            pl: `${getSideBarWidth(screenwidth)}`,
            pt: `${TopPadding}px`,
            height: `calc(100vh - ${TopPadding}px)`,
            width: `calc(100vw - ${getSideBarWidth(screenwidth)})`,
          }}
        >
          <Box
            sx={{
              padding: screenwidth > 768 ? '30px' : '30px 2.5vw',
            }}
          >
            {children}
          </Box>
        </Box>
      </DevicesContextProvider>
    </Box>
  );
};

export default OutletWrapper;
